<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="sl-article-details">

        <!-- Order type : LENS -->
        <template v-if="orderType == 'LENS'">
            <!-- patient name - external reference - prototype -->
            <div class="flex flex-wrap mr-auto">
                <!-- patient name -->
                <div class="text-sm text-gray-500">
                    {{ patient }}
                </div>
                <!-- external reference -->
                <div v-if="row.extra?.ext_ref" class="ml-2 text-sm text-gray-500">
                    {{ row.extra.ext_ref }}
                </div>
                <!-- prototype -->
                <div class="w-full text-xs text-gray-400 whitespace-nowrap text-ellipsis">
                    {{ prototype }}
                </div>
            </div>
            <!-- Lens Return Status -->
            <div v-if="row.has_been_returned" class="flex items-center mr-3">
                <div class="text-gray-300 text-xl font-bold">
                    R
                </div>
            </div>
            <!-- side -->
            <div class="flex items-center justify-center">
                <sl-lens-side :side="row.article_data.LENS_SIDE" />
            </div>
        </template>

        <!-- Order type : TRIALSET -->
        <template v-else-if="orderType == 'TRIALSET'">
            <!-- article -->
            <div class="text-sm text-gray-500">
                {{ getLabel(row) }}
            </div>
            <div v-is-staff>
                <!-- Trial Set Customer -->
                <span v-if="row.article_data?.trial_set_customer">
                    {{ row.article_data.trial_set_customer }}
                    <span class="sl-order-subcell__separator">&middot;</span>
                </span>
                <!-- Trial Set Price -->
                <span v-if="row.article_data?.trial_set_price" :class="{ 'blur': !pricesVisible }">
                    {{ row.currency_code }}
                    {{ row.article_data.trial_set_price.toFixed(2) }}/{{ $t('common.lens') }}
                </span>
            </div>
            <!-- external reference -->
            <div v-if="row.extra?.ext_ref" class="ml-2 text-sm text-gray-500">
                {{ row.extra.ext_ref }}
            </div>
        </template>

        <!-- Order type : DEFAULT -->
        <template v-else>
            <span class="text-sm text-gray-500">
                {{ getLabel(row) }}
            </span>
            <!-- external reference -->
            <div v-if="row.extra?.ext_ref" class="ml-2 text-sm text-gray-500">
                {{ row.extra.ext_ref }}
            </div>
        </template>

    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

import { has } from 'lodash-es';

export default
{
    name: 'OrderDetailsCell',

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        rows:
        {
            type:     Array,
            required: true,
        },

        column:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },

    computed:
    {
        orderType()
        {
            if(has(this.row, 'article_data.PROTOTYPE_CODE'))
            {
                return 'LENS';
            }
            else if(this.row.article.code.includes('TRIALSET'))
            {
                return 'TRIALSET';
            }

            return 'DEFAULT';
        },

        pricesVisible()
        {
            return this.$store.state.pricesVisible;
        },

        patient()
        {
            if(this.row.article_data.PATIENT_REFERENCE1)
            {
                return this.row.article_data.PATIENT_REFERENCE1;
            }
            else if(this.row.article_data.PATIENT_ID)
            {
                const patient = this.$store.getters['patients/getById'](this.row.article_data.PATIENT_ID);

                return patient.reference1 ? patient.reference1 : '-';
            }
            else
            {
                return '-';
            }
        },

        prototype()
        {
            const prototypeCode = this.row.article_data?.PROTOTYPE_CODE || this.row.article_data?.PROTOTYPE_CODE_LEGACY;

            return this.$store.state.prototypes.prototypes.find(p => p.code === prototypeCode)?.label || prototypeCode;
        },
    },

    methods:
    {
        getLabel(order)
        {
            return order.article.label || order.article.code || '';
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style scoped>
@reference "#main.css";


.sl-article-details
{
    min-height: 38px;
    @apply flex items-center w-full;
}

</style>
